import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  provideAppInitializer,
  provideZoneChangeDetection
} from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { primeConfig } from '@cfg/design/prime.config';
import { initializePrimeTranslation } from '@cfg/i18n/initializer';
import { translationConfig } from '@cfg/i18n/translation.config';
import { SecurityLoaders } from '@cfg/security/loaders';
import { getCookieDi } from '@cfg/services/cookie-di';
import { APP_ROUTES } from '@view/routes';
import { AppComponent } from '@view/app.component';
import { GetTasksUseCase } from './app/domain/usecase/task/get-tasks.usecase';
import { TaskRepository } from './app/domain/service/task/task-repository';
import { InMemoryTaskRepository } from './app/infrastructure/adapters/task/in-memory-task.repository';

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(APP_ROUTES),
    provideHttpClient(withInterceptors(SecurityLoaders.loadInterceptors())),
    provideAnimations(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAppInitializer(() => initializePrimeTranslation()),
    ...primeConfig,
    ...translationConfig,
    ...getCookieDi,
    GetTasksUseCase,
    { provide: TaskRepository, useClass: InMemoryTaskRepository }
  ]
}).catch((err) => console.error(err));
